import React from 'react';
import PropTypes from 'prop-types';

// The x removes the tag from THIS record only. The tag itself is shared, so the
// request is sent by name + taggable, mirroring how a tag is added.
function TagItem({ tag, onRemove }) {
  return (
    <b
      className="cart-tag"
      title={tag.name}
      style={tag.color ? { backgroundColor: tag.color } : undefined}
    >
      <span className="cart-tag__label">{tag.name}</span>
      {onRemove && (
        <span
          className="cart-tag__remove"
          role="button"
          tabIndex={0}
          title={`Remove ${tag.name}`}
          onClick={() => onRemove(tag)}
          onKeyPress={() => onRemove(tag)}
        >
          &times;
        </span>
      )}
    </b>
  );
}

TagItem.propTypes = {
  onRemove: PropTypes.func,
};

TagItem.defaultProps = {
  onRemove: null,
};

export default TagItem;
